import { SET_SIDE_PANEL_SELECTED_HOLIDAY } from 'actions/sidePanel/holidays';
import {
  SIDE_PANEL_CLEAN_UP,
  UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
  ACCEPT_PENDING_SIDE_PANEL_CONTENT,
  REJECT_PENDING_SIDE_PANEL_CONTENT,
} from 'actions/sidePanel';

const defaultState = {
  selectedHoliday: null,
};

export default function sidePanelHoliday(state = defaultState, action) {
  switch (action.type) {
    case SIDE_PANEL_CLEAN_UP:
      return {
        ...defaultState,
      };
    case UPDATE_SIDE_PANEL_PENDING_PROPERTIES:
      return {
        ...state,
        pendingProps: { ...state.pendingProps },
      };
    case SET_SIDE_PANEL_SELECTED_HOLIDAY:
      if (state.pendingProps) {
        return {
          ...state,
          pendingProps: {
            ...state.pendingProps,
            selectedHoliday: action.payload,
          },
        };
      }
      return {
        ...state,
        selectedHoliday: action.payload,
      };
    case ACCEPT_PENDING_SIDE_PANEL_CONTENT:
      return {
        ...state,
        ...state.pendingProps,
        pendingProps: null,
      };
    case REJECT_PENDING_SIDE_PANEL_CONTENT:
      return {
        ...state,
        pendingProps: null,
      };
    default:
      return state;
  }
}
